import { CHANGE_REQUESTS_ROUTE_ID } from './common';
import ChangeRequestsAdmin from './components/ChangeRequestsAdmin';

export default {
    [CHANGE_REQUESTS_ROUTE_ID]: () => <ChangeRequestsAdmin />
};
